// https://api.api-ninjas.com/v1/loremipsum?paragraphs=

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { LoremApiType } from '../../types';

export const loremApi = createApi({
  reducerPath: 'loremApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: 'https://api.api-ninjas.com/v1/',
    headers: { 'X-Api-Key': process.env.REACT_APP_LOREM_API_KEY || ''} }), 
  endpoints: (builder) => ({
    getLoremApi: builder.query<LoremApiType, string>({
      query: () => `/loremipsum?paragraphs=1`,
    }),
  }),
});

// export hooks for usage in functional components
// auto-generated based on the defined endpoints
export const { useGetLoremApiQuery } = loremApi;
